import {Component} from '@angular/core';
import {CoreService} from "~/app/core/core.service";
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import OneSignal from 'onesignal-cordova-plugin';
import {Platform} from "@ionic/angular";
import {UserInfo} from '~/app/core/model/user-info';
import {UserProfileService} from "~/app/core/user-profile-service/user-profile.service";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
    hideNav = false;
    showSpinner = true;
    isNativeApp = false;
    userInfo: UserInfo;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private core: CoreService,
        private platform: Platform,
        private readonly userProfileService: UserProfileService,
    ) {
      this.initializeApp();
    }

    initializeApp() {
      this.platform.ready().then(() => {
        this.userInfo = this.userProfileService.userInfo;

        // check if we're running in native app or web browser
        if (navigator.userAgent.indexOf('median') > -1)
          this.isNativeApp = true;

        // initialize OneSignal for push messages
        if (window['cordova']) {
        }
        else {
          console.log('cordova not found. OneSignal cannot be initialized');
        }
        // but we're going to try anyway
        try {
          this.OneSignalInit();  // See https://documentation.onesignal.com/docs/ionic-sdk-setup
        } catch (e) {
          // OneSignal will throw an error attempting to initialize on a web device, so just ignore
          console.log('Error initializing OneSignal: ' + e);
          console.trace();
          console.log(e.toString());
        }
      });
    }

    ngOnInit() {
        this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((e: NavigationStart) => {
            this.showSpinner = true;
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
            let activatedRoute = this.route;

            while (activatedRoute) {
                this.hideNav = activatedRoute.snapshot.data.hideNav;
                activatedRoute = activatedRoute.firstChild;
            }

            this.showSpinner = false;
        });
    }

    // Call this function when your app starts
    OneSignalInit(): void {
      // console.log(OneSignal);
      // console.log(OneSignal.Debug);
      // console.log(OneSignal.Debug.setLogLevel);
      // console.log(OneSignal.initialize);
      // console.log(window['cordova']);
      // Uncomment to set OneSignal device logging to VERBOSE
      OneSignal.Debug.setLogLevel(6);

      // Uncomment to set OneSignal visual logging to VERBOSE
      OneSignal.Debug.setAlertLevel(6);

      OneSignal.initialize("8d958ff7-9231-4251-92e3-ab7deb20b2a4");
      if (this.userInfo) {
        console.log("added OneSignal user info for " + this.userInfo.firstName + " " + this.userInfo.lastName)
        OneSignal.User.addEmail(this.userInfo.email);
        OneSignal.User.addAlias("name", this.userInfo.firstName + " " + this.userInfo.lastName);
        OneSignal.User.addAlias("id", this.userInfo.id.toString());
        OneSignal.login(this.userInfo.id.toString());
      }

      let myClickListener = async function(event) {
        let notificationData = JSON.stringify(event);
      };
      OneSignal.Notifications.addEventListener("click", myClickListener);


      // Prompts the user for notification permissions.
      //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
      OneSignal.Notifications.requestPermission(true).then((accepted: boolean) => {
        console.log("User accepted notifications: " + accepted);
      });

      console.log("OneSignalInit completed");
    }

}
